import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SchoolConfig } from 'src/app/models/school/schooladminitem.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UtilService } from 'src/app/services/util.service';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-useraccessskin',
  templateUrl: './useraccessskin.component.html',
  styleUrls: ['./useraccessskin.component.css'],
})
export class UseraccessskinComponent implements OnInit, AfterViewInit {
  display: boolean = true;
  //subdomain: string;
  //schoolConfig: SchoolConfig = new SchoolConfig();
  schoollogourl: string;
  constructor(
    public headerinfo: ComponentheaderService,
    public util: UtilService
  ) { }
  ngAfterViewInit(): void {
    // debugger;
    // if(!this.loginComponent || this.loginComponent.display){
    //   this.display = true;
    // }
  }

  currentDate: Date = new Date();

  async ngOnInit() {

    this.schoollogourl = (await this.util.getStaticSchoolInfoBundle()).schoolInfo.logoImg;
  }
}
